import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";
import Checkbox from "@mui/material/Checkbox";
import MDBadge from "components/MDBadge";

function CardsTableData({ data, selectedIds, onToggle, onEdit, onDelete }) {
  const columns = [
    { Header: "", accessor: "checkbox", align: "center", width: "2%" },
    { Header: "Code", accessor: "code", align: "left" },
    { Header: "Description", accessor: "description", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "action", accessor: "action", align: "center" },
  ];

  const rows = (data || []).map((a) => ({
    checkbox: (
      <Checkbox size="small" checked={selectedIds.includes(a.id)} onChange={() => onToggle(a.id)} />
    ),
    code: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.code}
      </MDTypography>
    ),
    description: (
      <MDTypography variant="caption" color="text" fontWeight="regular">
        {a.description}
      </MDTypography>
    ),
    status: (
      <MDBadge
        badgeContent={a.status}
        size="md"
        container
        // optional: color mapping
        color={String(a.status).toLowerCase() === "active" ? "success" : "secondary"}
      />
    ),
    action: (
      <div>
        <IconButton size="small" onClick={() => onEdit(a)}>
          <Icon fontSize="small">edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => onDelete(a)}>
          <Icon fontSize="small">delete</Icon>
        </IconButton>
      </div>
    ),
  }));

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
    />
  );
}

CardsTableData.propTypes = {
  data: PropTypes.array.isRequired,
  selectedIds: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CardsTableData;
